export default __webpack_public_path__ + "static/media/addUserWhite.b6a33bdb.svg";